export const HELP_ARTICLE_ID = 'd1de5e4f-9ecf-4b3a-bda6-fb1edbc53852';
